export default "__VITE_ASSET__5LC2u0IT__"